import React, { SVGProps } from "react";

const SvgRoof2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 350 300"
    {...props}
  >
    <defs>
      <linearGradient
        id="roof2_svg__c"
        x1={244.346}
        y1={223.48}
        x2={217.419}
        y2={176.84}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.631} stopColor="#b8c9d5" stopOpacity={0} />
        <stop offset={1} stopColor="#b8c9d5" stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof2_svg__a"
        x1={61.22}
        y1={246.436}
        x2={114.499}
        y2={154.154}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.316} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="roof2_svg__d"
        x1={288.625}
        y1={246.588}
        x2={245.939}
        y2={172.654}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.502} stopColor="#b8c9d5" stopOpacity={0} />
        <stop offset={1} stopColor="#b8c9d5" stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof2_svg__e"
        x1={216.207}
        y1={276.596}
        x2={216.207}
        y2={179.656}
        xlinkHref="#roof2_svg__a"
      />
      <linearGradient
        id="roof2_svg__b"
        x1={328.731}
        y1={138.318}
        x2={328.731}
        y2={112.574}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.117} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="roof2_svg__f"
        x1={309.212}
        y1={189.189}
        x2={309.212}
        y2={163.445}
        xlinkHref="#roof2_svg__b"
      />
      <linearGradient
        id="roof2_svg__g"
        x1={236.645}
        y1={239.766}
        x2={236.645}
        y2={214.021}
        xlinkHref="#roof2_svg__b"
      />
      <linearGradient
        id="roof2_svg__h"
        x1={194.223}
        y1={216.283}
        x2={194.223}
        y2={190.539}
        xlinkHref="#roof2_svg__b"
      />
      <linearGradient
        id="roof2_svg__i"
        x1={21.399}
        y1={187.128}
        x2={21.399}
        y2={149.712}
        xlinkHref="#roof2_svg__b"
      />
      <linearGradient
        id="roof2_svg__j"
        x1={133.033}
        y1={251.43}
        x2={133.033}
        y2={225.685}
        xlinkHref="#roof2_svg__b"
      />
    </defs>
    <path fill="none" d="M0 0h350v300H0z" />
    <path
      fill="url(#roof2_svg__c)"
      d="M133.033 225.685v62.062l195.699-113.111v-62.062L133.033 225.685z"
    />
    <path
      fill="url(#roof2_svg__a)"
      d="M133.033 225.685v62.062L21.399 223.445v-73.733l50.177-20.34 61.457 96.313z"
    />
    <path
      fill="url(#roof2_svg__d)"
      d="M236.651 209.588v67.008l72.571-42.025v-72.335l-33.761-6.627-38.81 53.979z"
    />
    <path
      fill="url(#roof2_svg__e)"
      d="M237.521 209.588v67.008l-42.628-24.604v-72.336l42.628 29.932z"
    />
    <g fill="#6d9faf">
      <path d="M75.875 153.952v11.261l-9.362-5.393v-11.261l9.362 5.393zM87.344 160.574v11.261l-9.363-5.393V155.18l9.363 5.394zM75.875 167.439V178.7l-9.362-5.393v-11.261l9.362 5.393zM87.344 174.061v11.261l-9.363-5.393v-11.261l9.363 5.393z" />
    </g>
    <path
      fill="#2176a8"
      d="M340 105.914 133.033 225.685l-62.024-96.004L278.43 10 340 105.914z"
    />
    <path
      fill="#47d5ff"
      d="M278.43 10 71.009 129.681 10 154.361l207.252-119.78L278.43 10z"
    />
    <path
      fill="#2682b5"
      d="m204.979 116.377 74.848 24.359 40.813 23.444-42.14-5.569-73.521-42.234z"
    />
    <path
      fill="#47e2ff"
      d="m204.979 116.377-10.558 73.783 42.186 23.075 41.893-54.624-73.521-42.234z"
    />
    <path fill="url(#roof2_svg__b)" d="M328.231 112.574h1v25.745h-1z" />
    <path fill="url(#roof2_svg__f)" d="M308.712 163.445h1v25.745h-1z" />
    <path fill="url(#roof2_svg__g)" d="M236.145 214.021h1v25.745h-1z" />
    <path fill="url(#roof2_svg__h)" d="M193.723 190.539h1v25.745h-1z" />
    <path fill="url(#roof2_svg__i)" d="M20.899 149.712h1v37.416h-1z" />
    <path fill="url(#roof2_svg__j)" d="M132.533 225.685h1v25.745h-1z" />
    <path
      fill="none"
      stroke="#002839"
      strokeMiterlimit={10}
      d="M71.43 128.909 278.43 10M278.5 158.611l-73.521-42.234"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m194.421 190.16-61.388 35.525-62.024-96.004L10 154.361l207.252-119.78L278.43 10 340 105.914l-60.173 34.822 40.813 23.444-42.14-5.569-41.893 54.624-42.186-23.075z"
    />
    <path
      fill="none"
      stroke="#002839"
      strokeMiterlimit={10}
      d="m279.827 140.736-74.848-24.359-10.558 73.783"
    />
  </svg>
);

export default SvgRoof2;
